<template>
  <div class="card" @click="toDetail">
    <img
      :src="props.data?.materialPhotos || ''"
      style="object-fit: contain"
      @error="setDefaultImage"
    />
    <div class="content">
      <p class="name">{{ props.data.materialName }}</p>
      <div class="scoreBox">
        <img src="../../../../assets/images/score/redBase.png" />
        <p class="score">
          {{ props.data.externalSalePrice }}{{ lang('积分兑换') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { GoodsRecordModal } from '@/model/score/GoodsModel'
import img_failed from '@/assets/images/score/img_failed.png'
import lang from '@/langs'
const setDefaultImage = (event) => {
  event.target.src = img_failed
}
const props = defineProps<{ data: GoodsRecordModal }>()
const emits = defineEmits(['toDetail'])
const toDetail = () => {
  emits('toDetail')
}
</script>

<style scoped lang="less">
.card {
  border-radius: 8px;
  width: 100%;
  background: #fff;
  > img {
    width: 100%;
    border-radius: 8px;
    aspect-ratio: 1 / 1;
    border: 1px solid rgba(128, 128, 128, 0.16);
  }
  .content {
    display: flex;
    flex-direction: column;
    margin-top: 12px;
    .name {
      color: rgba(60, 60, 60, 1);
      font-size: 14px;
      margin-bottom: 8px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2; /* 限制显示 2 行 */
      overflow: hidden;
    }
    .scoreBox {
      display: flex;
      flex-direction: row;
      align-items: center;
      > img {
        width: 10px;
        height: 10px;
        margin-right: 4px;
      }
      .score {
        color: rgba(255, 0, 0, 1);
        font-size: 12px;
      }
    }
  }
}
</style>
